import { Tabs } from 'antd';
import { useNavigate } from 'react-router';
import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';
import { COMPANY_TAB_LABELS, companyTabPath, type CompanyTab } from '../company-settings.paths';
import { companyTabsFor } from '../policies/company-tabs';

/** The strip under the Company page header; each tab is its own route, so a reload stays on it. Shows only the tabs the user may open. */
export function CompanyTabs({ active }: { active: CompanyTab }) {
  const navigate = useNavigate();
  const { state } = useCurrentUser();
  const tabs = companyTabsFor(state.status === 'authenticated' ? state.user.permissions : []);

  return (
    <Tabs
      activeKey={active}
      onChange={(key) => navigate(companyTabPath(key as CompanyTab))}
      items={tabs.map((tab) => ({ key: tab, label: COMPANY_TAB_LABELS[tab] }))}
    />
  );
}
